import clsx from 'clsx';
import { FC } from 'react';
import { HiCheck } from 'react-icons/hi';

export interface BidReviewStep {
  id: string;
  label: string;
}

interface BidReviewStepperProps {
  steps: BidReviewStep[];
  activeIndex: number;
}

export const BidReviewStepper: FC<BidReviewStepperProps> = ({ steps, activeIndex }) => (
  <div className="flex w-full items-start justify-center">
    {steps.map((step, index) => {
      const isCompleted = index < activeIndex;
      const isActive = index === activeIndex;
      const isFirst = index === 0;
      const isLast = index === steps.length - 1;
      return (
        <div key={step.id} className="flex flex-1 flex-col items-center">
          <div className="flex w-full items-center">
            <div
              className={clsx(
                'h-[2px] flex-1',
                isFirst
                  ? 'bg-transparent'
                  : index <= activeIndex
                    ? 'bg-day-neutral-dark'
                    : 'bg-day-light-1',
              )}
            />
            <div
              className={clsx(
                'flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm font-semibold transition-colors',
                isCompleted || isActive
                  ? 'bg-day-neutral-dark text-day-light-5'
                  : 'bg-day-light-2 text-day-neutral-subtle',
              )}
            >
              {isCompleted ? <HiCheck size={18} /> : index + 1}
            </div>
            <div
              className={clsx(
                'h-[2px] flex-1',
                isLast ? 'bg-transparent' : isCompleted ? 'bg-day-neutral-dark' : 'bg-day-light-1',
              )}
            />
          </div>
          <span
            className={clsx(
              'mt-2 text-center text-sm',
              isActive ? 'font-semibold text-day-neutral-dark' : 'text-day-neutral-subtle',
            )}
          >
            {step.label}
          </span>
        </div>
      );
    })}
  </div>
);
